export const classes = {
  clickable: 'cursor-pointer',
  labeledCell: 'py-4',
  name: 'name-label-cell-name text-grey-8 dark:text-mauve-1 font-medium text-small',
  label: 'text-xs text-grey-6 dark:text-mauve-3 font-semibold tracking-wide',
};

export const styles = {
  clickable: {
    '&:hover .name-label-cell-name': {
      textDecoration: 'underline',
    },
  },
};
